import axios from 'axios';

// Single source of truth for money formatting, using the web-standard
// Intl.NumberFormat. The ISO currency code + locale come from the backend
// (/api/config, set via CURRENCY_CODE / CURRENCY_LOCALE in the server .env),
// so changing currency needs no client rebuild. Intl handles the correct
// symbol, its placement, decimal count (PKR/USD 2, JPY 0, KWD 3) and
// separators for every currency automatically.
//
// The last-seen settings are cached in localStorage to avoid a USD→PKR
// flicker on page load.

let code = localStorage.getItem('currencyCode') || 'USD';
let locale = localStorage.getItem('currencyLocale') || 'en-US';
let formatter = null;

const buildFormatter = () => {
  try {
    formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: code });
  } catch (_) {
    // Bad code/locale in config — fall back to a safe default rather than crash
    formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  }
};
buildFormatter();

export const initCurrency = async () => {
  try {
    const res = await axios.get('/api/config');
    const c = res.data?.currency;
    if (c?.code) {
      code = c.code;
      locale = c.locale || 'en-US';
      localStorage.setItem('currencyCode', code);
      localStorage.setItem('currencyLocale', locale);
      buildFormatter();
    }
  } catch (_) { /* keep cached/default settings */ }
};

export const currencyCode = () => code;

// fmtMoney(1300) -> "$1,300.00" / "Rs 1,300.00" / "1.300,00 €" — the
// standard format for the configured currency. The second argument is
// accepted for backwards compatibility but Intl already applies each
// currency's standard decimal count, so it changes nothing.
export const fmtMoney = (n) => formatter.format(Number(n) || 0);
